import React, { useEffect, useState } from "react";
import i18n from '../../i18n';

import {
  Button,
  Menu,
  MenuItem
} from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";



import { parkLookupDiscount, serverLookupDiscount } from "../Bonification/lookup";


export class SiteSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sites: serverLookupDiscount(),
      selection: undefined
    };
  }

  render() {
    return (
      <div>
        <Select
          items={this.state.sites}
          itemRenderer={(item, { select, modifiers }) => {
            return <MenuItem
              key={item.id}
              label={item.id}
              text={i18n.t("site") + " n°" + item.id + " (" + item.name + ")"}
              onClick={() => {
                this.props.onSelect(item.id, item);
                this.setState({ selection: item });
              }}
            />
          }}
          itemListRenderer={({ items, itemsParentRef, query, renderItem }) => {
            const renderedItems = items.map(renderItem).filter(item => (item != null && item.props.text != null && item.props.text.toUpperCase().includes(query.toUpperCase())));
            return (
              <Menu ulRef={itemsParentRef}>
                <MenuItem
                  disabled={true}
                />
                {renderedItems}
              </Menu>
            );
          }}
        >
          <Button
            text={this.state.selection !== undefined ? i18n.t("site") + " n°" + this.state.selection.id + " (" + this.state.selection.name + ")" : i18n.t("select a site")} rightIcon="double-caret-vertical" />
        </Select>
      </div >);
  }
}

export default function SiteParkListSelect(props) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      // const server = await serverLookupDiscount();
      const parks = await parkLookupDiscount();
      const selected = props.selected ?? [];

      let items = [];
      for (const park of parks) {
        if (selected.map((s) => s.id).includes(park.pk)) {
          continue;
        }
        items.push({
          id: park.id,
          parkId: park.id,
          name: park.server.name + " - " + park.name,
          key: park.server.infoSup.publicId.site + "-" + park.id,
          server: park.server.id
        });
      }
      setItems(items);
    }
    fetchData();
  }, [props.selected]);

  return (
    <div>
      {open ? (
        <Select
          items={items}
          itemRenderer={(item, { select, modifiers }) => {
            return (
              <MenuItem
                key={item.id}
                label={item.parkId}
                text={item.name}
                onClick={() => {
                  props.onSelect(item.id, item);
                  setOpen(false);
                }}
                itemListRenderer={({
                  items,
                  itemsParentRef,
                  query,
                  renderItem
                }) => {
                  const renderedItems = items
                    .map(renderItem)
                    .filter(
                      (item) =>
                        item != null &&
                        item.props.text != null &&
                        item.props.text
                          .toUpperCase()
                          .includes(query.toUpperCase())
                    );
                  return (
                    <Menu ulRef={itemsParentRef}>
                      <MenuItem disabled={true} />
                      {renderedItems}
                    </Menu>
                  );
                }}
              />
            );
          }}
          itemListRenderer={({
            items,
            itemsParentRef,
            query,
            renderItem,
          }) => {
            const renderedItems = items
              .map(renderItem)
              .filter(
                (item) =>
                  item != null &&
                  item.props.text != null &&
                  item.props.text.toUpperCase().includes(query.toUpperCase())
              );
            return (
              <Menu ulRef={itemsParentRef}>
                <MenuItem disabled={true} />
                {renderedItems}
              </Menu>
            );
          }}
        >
          <Button
            text={i18n.t("select a parks to add")}
            rightIcon="double-caret-vertical"
          />
        </Select>
      ) : (
        <Button
          icon="add"
          text={props.label || ""}
          onClick={() => setOpen(true)}
        />
      )}
    </div>
  );
}
